import React from 'react';

const PHRASE = 'EL SECRETO ES EL CUADRADO\u2002·\u2002ARTESANAL\u2002·\u2002LAS PALMAS DE GRAN CANARIA\u2002·\u2002HECHO A MANO\u2002·\u2002';
const REPEATED = Array(8).fill(PHRASE).join('');

const MarqueeStrip = () => (
  <div
    data-testid="marquee-strip"
    className="bg-[#2C2C2A] py-4 overflow-hidden select-none"
  >
    <div className="marquee-track font-serif text-[#F5F0E8] text-base tracking-widest whitespace-nowrap">
      <span aria-hidden="true">{REPEATED}</span>
      <span aria-hidden="true">{REPEATED}</span>
    </div>
  </div>
);

export default MarqueeStrip;
